/**
 * useQueueEvents — one element's lifecycle timeline, fetched on demand: the
 * hook lives in the popover CONTENT component, which only mounts when the
 * popover opens, so the request fires on first open and caches per element.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useQuery } from '@tanstack/react-query';
import type { FlowLayer } from '@trafficpulse/shared';

import type { QueueProvider } from '@/features/trackers/flow-optimizer/queue-provider';
import { getQueueEvents } from '../../../services/flow-optimizer-queue-api';
import { queueKeys } from '../../../hooks/useFlowOptimizerQueue';

export interface QueueEventsArgs {
  campaignId: string;
  provider: QueueProvider;
  layer: FlowLayer;
  bankId: string;
}

export function useQueueEvents(args: QueueEventsArgs) {
  const { campaignId, provider, layer, bankId } = args;
  return useQuery({
    queryKey: queueKeys.queueEvents(provider, campaignId, layer, bankId),
    queryFn: () => getQueueEvents(campaignId, { layer, bankId }, provider),
    staleTime: 30_000,
  });
}
